import {
  InvoicePaymentType,
  Language,
  InvoicePaymentPeriod,
  InvoiceStatus,
  NotificationStatus,
  WalletOrderType,
  ActivityTemplateStatus
} from '@link/admin/services/const';

export default {
  common: {
    edit: '編集',
    search: '検索',
    keyword: 'キーワード',
    action: '操作',
    status: 'ステータス',
    clickToUpload: 'アップロード',
    uploading: 'アップロード中',
    copy: 'コピー',
    delete: '削除',
    continueConfirm: '続行してもよろしいですか？',
    confirmDelete: '{{name}}を削除してもよろしいですか？',
    account: 'アカウント',
    signOut: 'サインアウト'
  },
  layouts: {
    sidebar: {
      contracts: '契約管理',
      suppliers: '催行会社管理',
      agents: '旅行代理店管理',
      finance: '支払管理',
      notifications: '通知管理',
      dataExport: 'データ出力',
      activities: '在庫商品一覧',
      tools: 'ツール一覧',
      opsFreeze: 'OPS凍結'
    }
  },
  views: {
    opsFreeze: {
      separatorHint:
        '改行・スペース・カンマ（, ，）・読点（、）で区切って入力できます',
      register: '登録する',
      bookingIdsInput: '予約番号を入力',
      maxBookingCount: '最大{{max}}件',
      exceedMaxCount: '最大件数を超えています',
      createSuccess: '登録しました',
      freezeOperation: '凍結操作',
      unfreezeOperation: '解凍操作',
      reason: '備考',
      reasonPlaceholder: '操作理由を入力してください（{{max}}文字以内）',
      submitFreeze: '凍結する',
      submitUnfreeze: '解凍する',
      freezing: '凍結中',
      unfreezing: '解凍中',
      processingHint: '処理完了時、CSVが自動でダウンロードされます',
      freezeSuccess: '凍結が完了しました',
      unfreezeSuccess: '解凍が完了しました',
      titleWithCount: '凍結記録一覧・{{count}}件',
      newFreeze: '新規凍結',
      batchNo: '番号',
      createdAt: '作成日時',
      status: '状態',
      targetBookings: '対象予約',
      lastOperation: '最終操作',
      bookingCount: '{{count}}件',
      statusLabel: {
        frozen: '凍結済',
        unfrozen: '解凍済',
        notOperated: '未操作'
      },
      action: {
        freeze: '凍結',
        unfreeze: '解凍'
      }
    },
    activities: {
      pageTitle: '在庫商品一覧',
      searchTitle: '商品検索',
      activityId: '商品ID',
      templateId: 'Template ID',
      activityUrl: '商品URL',
      title: '商品名',
      supplier: 'サプライヤー',
      supplierId: 'サプライヤーID',
      supplierName: 'サプライヤー名',
      salesStatus: '商品表示',
      listDisplay: '商品一覧表示',
      category: 'カテゴリ',
      country: '商品国・地域',
      confirmationType: '在庫タイプ',
      inSalePeriod: '販売期間内',
      unspecified: '指定なし',
      salePeriod: '販売期間',
      netPrice: '卸価格（NET）',
      grossPrice: '販売価格（GROSS）',
      unlimited: '無期限',
      downloadCsv: 'CSVをダウンロード',
      snapshotHint:
        '表示されているデータは前日時点のものです（毎日深夜更新）。最終更新日時：{{time}}',
      templateStatus: {
        [ActivityTemplateStatus.ActivityTemplateStatusPublished]: '公開済み',
        [ActivityTemplateStatus.ActivityTemplateStatusReviewing]: '公開申請中',
        [ActivityTemplateStatus.ActivityTemplateStatusApproved]: '公開確認済',
        [ActivityTemplateStatus.ActivityTemplateStatusDraft]: '下書き'
      }
    },
    dataExport: {
      period: '期間',
      dataExport: 'データ出力',
      bookingData: '予約データ',
      download: 'ファイルダウンロード',
      monthLabel: '{{year}}年{{month}}月',
      downloadHint:
        'ボタンを押し、自動ダウンロードが始まるまで、画面を閉じないでください。',
      currentMonthHint:
        '当月データの場合、データの準備が完了次第、Slackチャンネルへ配信されます。少々お待ちください。',
      slackNotice: 'データの準備が完了次第、Slackチャンネルへ配信されます',
      notGenerated: '選択した期間のデータはまだ生成されていません'
    },
    dashboard: {
      title: 'ダッシュボード'
    },
    whitelist: {
      title: 'ホワイトリスト',
      add: 'ホワイトリストに追加',
      alertTitle: '旅行代理店追加'
    },
    activityPublish: {
      title: '商品公開管理',
      alertTitle: '商品公開の確認'
    },
    suppliersList: {
      title: '催行会社一覧',
      supplierCustomId: '催行会社ID',
      originalName: '催行会社名',
      englishName: '催行会社（英語）',
      country: '国・地域',
      action: '操作'
    },
    agentsList: {
      title: '旅行代理店一覧',
      originalName: '旅行代理店名',
      englishName: '旅行代理店名(EN)',
      paymentType: '支払方法',
      country: '国・地域'
    },
    orgList: {
      title: 'グループ管理',
      searchLabel: '旅行代理店'
    },
    agentAccountList: {
      title: 'アカウント管理',
      otaLabel: '旅行代理店',
      otaOrgLabel: '所属グループ'
    },
    apiKeyList: {
      title: 'api-key',
      otaId: '旅行代理店',
      otaOrgId: 'グループ',
      createTime: '作成日',
      addConfirmTitle: 'APIキー追加の確認',
      deleteConfirmTitle: 'APIキー削除の確認'
    },
    agentsCharge: {
      title: '残高チャージ'
    },
    financeTransactions: {
      title: '精算書/支払通知書',
      transactionStatus: '精算状況',
      keyword: '請求ID',
      difference: '取引種別',
      differenceOTA: '旅行代理店',
      differenceSupplier: '催行会社',
      dueDate: '支払通知書発行日',
      invoiceNumber: '請求ID',
      date: '対象期間',
      fromDate: '{{fromDate}}~{{toDate}}',
      currency: '通貨単位',
      amount: '支払金額合計',
      preAmount: '支払金額合計',
      lastAmount: '最終合計金額',
      adjustedAmount: '調整金額',
      finalAmount: '最終合計金額',
      adjust: '調整',
      showjust: '表示',
      paid: '入金完了',
      change: '支払済み',
      invoice: 'ダウンロード',
      jaInvoice: '支払通知書(日本語)',
      jaInvoiceDetails: '明細書(日本語)',
      enInvoice: '支払通知書(英語)',
      enInvoiceDetails: '明細書(英語)',
      attachment: '添付ファイル',
      changeTitle: '支払済みですか？',
      changeTitlePay: '入金完了ですか？',
      changeMessage: '取引状態は「支払済み」に変更します',
      changeMessagePay: '取引状態は「入金完了」に変更します',
      depositTitle: '取引情報',
      depositDate: '入金日',
      depositAmount: '入金金額',
      payDate: '支払日',
      payAmount: '出金金額',
      remark: '備考',
      confirmButton: '入金済み',
      invoiceList: '請求書リスト',
      payNoticeList: '支払い通知書リスト'
    },
    financeCharge: {
      title: '残高管理',
      agentId: '旅行代理店ID',
      agentName: '旅行代理店名',
      country: '国・地域',
      method: '決済方法',
      chargeCycle: '決済周期',
      status: '確認待ち/チャージ履歴',
      includeDeletedAgents: '削除した旅行代理店を含む',
      bulkDownload: '一括ダウンロード',
      downloadTitle: '残高記録をダウンロード',
      downloadMessage: '開始時間と終了時間を選択してください',
      startTime: '開始時間',
      endTime: '終了時間'
    },
    financeChargeHistory: {
      title: 'チャージ履歴',
      date: '日時',
      amount: '金額',
      invoice: '前払い請求書',
      status: '取引状態',
      note: '備考',
      code: '確認コード',
      change: '操作',
      invoiceStatusConfirmed: '着金確認',
      changeTitle: '着金を確認しました',
      changeConfirm: '該当アカウントへチャージを実行します',
      accountBalance: 'アカウント残高',
      accountBuffer: 'アカウントバッファー',
      deposit: '入金',
      changeAmount: '金額を変更',
      walletTitle: 'アカウント情報',
      amountType: '入金タイプ'
    },
    webHook: {
      title: 'WebHook設定',
      otaLabel: '旅行代理店',
      endpoint: 'End point',
      secretToken: 'Secret token'
    },
    notificationsList: {
      title: '手動通知',
      notification: '通知',
      resultCount: '検索結果: {{count}}件',
      notificationTitle: '通知名',
      notificationContent: '通知内容',
      sendTime: '送信時間',
      sendStatus: '送信状態',
      deleteConfirmTitle: 'この通知を削除してもよろしいですか？',
      confirmDelete: '削除する',
      deleteWarning: '一度削除すると、この通知を元に戻すことはできません。',
      addNew: '新規通知',
      send: '送信',
      confirmSend: '送信する',
      sendConfirmTitle: 'この通知を送信してもよろしいですか？',
      sendSuccess: '通知を送信しました',
      sendFailed: '通知の送信に失敗しました',
      sendWarning: '送信後、この通知は取り消すことができません。',
      resend: '再送信',
      pin: 'ピン留め',
      unpin: 'ピン留め解除',
      pinConfirmTitle: 'この通知をピン留めしてもよろしいですか？',
      unpinConfirmTitle: 'この通知のピン留めを解除してもよろしいですか？',
      confirmPin: 'ピン留めする',
      confirmUnpin: '解除する',
      pinSuccess: 'ピン留めしました',
      pinFailed: 'ピン留めに失敗しました',
      unpinSuccess: 'ピン留めを解除しました',
      unpinFailed: 'ピン留め解除に失敗しました',
      failedEmailsTitle: '送信失敗の詳細',
      failedEmailTo: '送信先',
      failedEmailReason: '失敗原因',
      failedEmailsLoadError: '失敗情報の取得に失敗しました',
      noFailedEmails: '失敗データがありません'
    },
    notificationDetail: {
      addTitle: '新規通知',
      editTitle: '通知を編集',
      notificationTitle: '通知名',
      notificationContent: '通知内容',
      relatedProducts: '関連商品',
      productAll: '関連しない',
      productSpecified: '特定商品を指定',
      productIdsHint: '商品ID入力(半角カンマで区切り)',
      sendTiming: '送信時間',
      sendNow: '即時送信',
      scheduled: '時間を設定して送信',
      scheduledTime: '予約日時',
      editLanguages: '編集言語',
      editLanguagesRequired: '編集言語を選択してください',
      langTitle: 'タイトル',
      langContent: '本文',
      targetScope: '対象範囲',
      targetAll: '全部',
      targetTypeEmail: 'ログインメールアドレス宛に送信',
      targetTypeRole: '権限を選択して送信',
      targetEmailDomain: '対象ドメイン',
      targetEmailDomainAdmin: 'Admin',
      targetEmailDomainOta: 'OTA',
      targetEmailDomainSupplier: 'SUP',
      toEmails: '送信先メールアドレス',
      toEmailsHint: 'メールアドレスを入力（半角カンマ「,」区切り）',
      roleOta: 'OTA',
      roleSupplier: 'SUP',
      roleAdmin: 'Admin',
      saveAsDraft: '一時保存',
      send: '送信',
      savedAsDraft: '一時保存しました',
      saveAsDraftFailed: '一時保存に失敗しました',
      sendSuccess: '通知を送信しました',
      sendFailed: '通知の送信に失敗しました'
    }
  },
  const: {
    invoicePaymentType: {
      [InvoicePaymentType.PostBankTransfer]: '後払い（銀行振込）',
      [InvoicePaymentType.PreLinkpay]: 'オンライン決済（前払い）',
      [InvoicePaymentType.PostLinkpay]: '後払い（LinkPay）',
      [InvoicePaymentType.PreCharge]: '銀行振込（前払い）'
    },
    invoicePaymentPeriod: {
      [InvoicePaymentPeriod.Monthly]: '月単位',
      [InvoicePaymentPeriod.Weekly]: '週単位',
      [InvoicePaymentPeriod.HalfMonthly]: '隔週単位'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '入金待ち',
      [InvoiceStatus.InvoiceStatusConfirmed]: '入金完了',
      [InvoiceStatus.InvoiceStatusPaid]: '入金確認中',
      [InvoiceStatus.InvoiceStatusCancelled]: 'キャンセル済'
    },
    walletOrderType: {
      [WalletOrderType.TypeBalance]: '残高チャージ',
      [WalletOrderType.TypeBuffer]: 'バッファーチャージ'
    },
    invoicePayStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '支払準備中',
      [InvoiceStatus.InvoiceStatusConfirmed]: '支払完了',
      [InvoiceStatus.InvoiceStatusPaid]: '入金確認待ち',
      [InvoiceStatus.InvoiceStatusCancelled]: 'キャンセル済'
    },
    notificationStatus: {
      [NotificationStatus.NotificationStatusSent]: '送信済み',
      [NotificationStatus.NotificationStatusTotalFailed]: '送信失敗',
      [NotificationStatus.NotificationStatusPartialFailed]: '一部送信失敗',
      [NotificationStatus.NotificationStatusSending]: '送信中',
      [NotificationStatus.NotificationStatusTempSaved]: '一時保存',
      [NotificationStatus.NotificationStatusScheduled]: '送信待ち'
    },
    notificationLanguage: {
      [Language.English]: '英語',
      [Language.Japanese]: '日本語',
      [Language.Korean]: '韓国語',
      [Language.SimplifiedChinese]: '中国語(簡体)',
      [Language.TraditionalChinese]: '中国語(繁体)'
    }
  }
};
